import React from 'react'
import { useTranslation } from 'react-i18next'

import { useAPIGetContractPartPincode } from '../../api/apiHooks/useAPIGetContractPartPincode'

type ExtraServiceReservationPincodeProps = {
  contractUuid: string
  contractPartId: number
}

export const ExtraServiceReservationPincode: React.FC<
  ExtraServiceReservationPincodeProps
> = ({ contractUuid, contractPartId }) => {
  const { t } = useTranslation(['storage'])

  const query = useAPIGetContractPartPincode(contractUuid, contractPartId, true)

  if (query.isLoading) {
    return (
      <div className="flex items-center gap-2">
        <div className="size-4 animate-spin rounded-full border-2 border-gray-300 border-t-blue-600" />
        <span className="text-sm text-gray-600">
          {t('extraService.pincode.loading')}
        </span>
      </div>
    )
  }

  if (query.isError) {
    return (
      <div className="text-sm text-red-600">
        {t('extraService.pincode.loadError')}
      </div>
    )
  }

  if (!query.data?.pincode) {
    return null
  }

  return (
    <div>{t('extraService.pincode.code', { pincode: query.data.pincode })}</div>
  )
}
